import {DeleteOutlined, FileOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import classNames from 'classnames';
import {formatBytes, isFile} from 'helpers/utils';
import {OrderedFileDto} from '../../../../../PRMGApiClient';

interface FileContainerProps {
  file: File | OrderedFileDto;
  className?: string;
  onRemove: () => void;
}

export const FileContainer: React.FC<FileContainerProps> = ({file, className, onRemove}) => (
  <div className={classNames('border border-gray rounded-lg flex items-center', className)}>
    <div className="w-full flex items-center content-center px-2">
      <div className="grow flex items-center">
        <div>
          <FileOutlined className="text-3xl text-gray mt-2" />
        </div>
        <div className="ml-2">
          <div className="text-sm text-darkGray mb-1">{isFile(file) ? file.name : file.fileName}</div>
          <div className="text-xs text-darkGray">
            <>
              {(isFile(file) ? new Date(file.lastModified) : file.createdDate)?.toISOString().slice(0, 10) ?? 'unknown'}
              , {file.size ? formatBytes(file.size) : 'unknown'}
            </>
          </div>
        </div>
      </div>
      <Button type="link" onClick={onRemove} icon={<DeleteOutlined className="text-lg" />} />
    </div>
  </div>
);
